<script>
import { Bar } from "vue-chartjs";
import {MONTH_LIST} from "../../utils/constants";
import * as Hammer from 'hammerjs';
export default {
  props: {
  selectedTenant: String,
  selectedYear: {},
  dashboardData: Array,
  },
  components: {
    Hammer,
  },
  name: "Barchart",
  extends: Bar,
  data() {
    return {
      datacollection: {
        labels: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
        datasets: [
          {
            label: "Total Trips",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "green",
            data: []
          },
          {
            label: "Completed Trips",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "#0456d0",
            data: []
          },
          {
            label: "Auto Cancelled Trips",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "grey",
            data: []
          }
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 1,
                stepSize: 2,
                reverse: false,
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false
      },
      tripsData: {
        totalTripsData: [],
        completedTripsData: [],
        autoCancelledTripsData: [],
      },
      tripTenants: [],
    };
  },

  methods: {
    getDataOnLoad() {
      const data = this.dashboardData.find(
        (vcl) => vcl.tenantId === this.selectedTenant
      );
      let completedTripsData = [];
      let autoCancelledTripsData = [];
      let totalTripsData = [];
      MONTH_LIST.forEach((item,index) => {
        completedTripsData.push({
          month: item,
          month_num: index+1,
        });
        autoCancelledTripsData.push({
          month: item,
          month_num: index+1,
        });
        totalTripsData.push({
          month: item,
          month_num: index+1,
        })
      });
      if(data && data.trips && data.trips.length>0) {
        data.trips.forEach(item => {
          totalTripsData.forEach(data => {
            if(item.month == data.month_num) {
              data.totalTripCount = item.totalTripCount;
              if(this.options.scales.yAxes[0].ticks.max < item.totalTripCount){
                this.options.scales.yAxes[0].ticks.max = item.totalTripCount
              }
            }
          });
          completedTripsData.forEach(data => {
            if(item.month == data.month_num) {
              data.completed_count = item.totalCompletedTrips;
            }
          });
          autoCancelledTripsData.forEach(data => {
            if(item.month == data.month_num) {
              data.auto_cancelled_count = item.totalAutoCancelledTrips;
            }
          });
        });
      } else {
        completedTripsData.forEach(item => {
        item.completed_count = 0;
        });
        autoCancelledTripsData.forEach(item => {
        item.auto_cancelled_count = 0;
        });
      }
      let totalTripsArray = completedTripsArray = totalTripsData.map(item => item.totalTripCount)
      let completedTripsArray = completedTripsData.map(item =>item.completed_count);
      let autocancelledTripsArray = autoCancelledTripsData.map(item =>item.auto_cancelled_count);

      this.tripsData = {
        totalTripsData: totalTripsArray,
        completedTripsData: completedTripsArray,
        autoCancelledTripsData: autocancelledTripsArray
      }
      this.datacollection.datasets[0].data = this.tripsData.totalTripsData;
      this.datacollection.datasets[1].data = this.tripsData.completedTripsData;
      this.datacollection.datasets[2].data = this.tripsData.autoCancelledTripsData;

      this.options.scales.yAxes[0].ticks.stepSize = Math.round(this.options.scales.yAxes[0].ticks.max / 10);
      this.renderChart(this.datacollection, this.options);
    }
  },
  mounted() {
    this.getDataOnLoad();
  },
};
</script>